import { ISettings } from "./Settings";

export const GET_SETTINGS_BEGIN = 'GET_SETTINGS_BEGIN';
export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS';
export const GET_SETTINGS_FAILURE = 'GET_SETTINGS_FAILURE';
export const SET_SETTINGS_BEGIN = 'SET_SETTINGS_BEGIN';
export const SET_SETTINGS_SUCCESS = 'SET_SETTINGS_SUCCESS';
export const SET_SETTINGS_FAILURE = 'SET_SETTINGS_FAILURE';
export const GET_ADMIN_SETTINGS_BEGIN = 'GET_ADMIN_SETTINGS_BEGIN';
export const GET_ADMIN_SETTINGS_SUCCESS = 'GET_ADMIN_SETTINGS_SUCCESS';
export const GET_ADMIN_SETTINGS_FAILURE = 'GET_ADMIN_SETTINGS_FAILURE';
export const SET_ADMIN_SETTINGS_BEGIN = 'SET_ADMIN_SETTINGS_BEGIN';
export const SET_ADMIN_SETTINGS_SUCCESS = 'SET_ADMIN_SETTINGS_SUCCESS';
export const SET_ADMIN_SETTINGS_FAILURE = 'SET_ADMIN_SETTINGS_FAILURE';

export interface ISettingsState {
    defaultFilters: string[];
    defaultEventCategories: string[];
    markerIsLiveHours: number;
    errorEmails: string[];
    activityDaysBack: number;
    loading: boolean,
    error?: string,
    settingsLoading: boolean,
    settingsError?: string
}

interface GetSettingsBeginAction {
    type: typeof GET_SETTINGS_BEGIN
}

interface GetSettingsSuccessAction {
    type: typeof GET_SETTINGS_SUCCESS,
    payload: ISettings
}

interface GetSettingsFailure {
    type: typeof GET_SETTINGS_FAILURE,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload: any
}

interface SetSettingsBeginAction {
    type: typeof SET_SETTINGS_BEGIN
}

interface SetSettingsSuccessAction {
    type: typeof SET_SETTINGS_SUCCESS,
    payload: ISettings
}

interface SetSettingsFailure {
    type: typeof SET_SETTINGS_FAILURE,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload: any
}

interface GetAdminSettingsBeginAction {
    type: typeof GET_ADMIN_SETTINGS_BEGIN
}

interface GetAdminSettingsSuccessAction {
    type: typeof GET_ADMIN_SETTINGS_SUCCESS,
    payload: { recipients: string[], activityDaysBack: number }
}

interface GetAdminSettingsFailure {
    type: typeof GET_ADMIN_SETTINGS_FAILURE,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload: any
}

interface SetAdminSettingsBeginAction {
    type: typeof SET_ADMIN_SETTINGS_BEGIN
}

interface SetAdminSettingsSuccessAction {
    type: typeof SET_ADMIN_SETTINGS_SUCCESS,
    payload: { recipients: string[], activityDaysBack: number }
}

interface SetAdminSettingsFailure {
    type: typeof SET_ADMIN_SETTINGS_FAILURE,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload: any
}

export type SettingsActionTypes = GetSettingsBeginAction | GetSettingsSuccessAction | GetSettingsFailure | SetSettingsBeginAction | SetSettingsSuccessAction | SetSettingsFailure | GetAdminSettingsBeginAction | GetAdminSettingsSuccessAction | GetAdminSettingsFailure | SetAdminSettingsBeginAction | SetAdminSettingsSuccessAction | SetAdminSettingsFailure;
